module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "cb-animate",
      rawName: "v-cb-animate",
      value: (true),
      expression: "true"
    }],
    staticClass: "cb-hp__wrapper"
  }, [_c('div', {
    directives: [{
      name: "cb-animate",
      rawName: "v-cb-animate",
      value: (false),
      expression: "false"
    }],
    staticClass: "cb-body",
    attrs: {
      "id": "cb-body"
    }
  }, [_c('div', {
    staticClass: "cb-body__wrap"
  }, [_c('div', {
    staticClass: "cb-error"
  }, [_c('div', {
    staticClass: "cb-error__content"
  }, [_vm._m(0), _vm._v("\n          " + _vm._s(_vm.message) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-error_icon"
  }, [_c('i', {
    staticClass: "icon-exclamation-circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6833b879"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/hosted-pages/ErrorComponent.vue
// module id = 116
// module chunks = 65 66 67 68